<template>
  <v-form v-model="valid">
    <v-card class="form">
      <v-card-text v-if="!ReadOnly" class="pb-0">
        قبل از ثبت درخواست پست مدرك تحصيلي، دقت به نكات ضروري زير لازم است:
        <br />
        <br />
        <ul>
          <li><b>دقت در وارد كردن آدرس، كدپستي و شماره همراه:</b> وارد كردن آدرس اشتباه و كدپستي باعث مي‌شود كه مدرك پست
            نخواهد
            شد و مبلغ واريزي عودت داده نمي شود.</li>
          <br />
          <li><b>دقت در انتخاب گزينه‌ها و پرداخت مبالغ:</b> در صورتي كه متقاضي اشتباهاً گزينه درخواست پست را انتخاب كند،
            در
            حالي كه درخواست ديگري داشته و مبلغي نيز واريز نمايد، مسئوليت اين اشتباه بر عهده متقاضي است و امكان عودت مبلغ
            واريزي وجود ندارد. </li>
        </ul>
        <br />
        لطفاً قبل از نهايي كردن ثبت درخواست پست مدرك، كليه اطلاعات و گزينه‌ها را به دقت بررسي و تاييد نماييد.
      </v-card-text>
      <v-card-text v-if="ReadOnly" class="pb-0">
        برای ارسال پستی مدرک میبایست مبلغ 120000 تومان واریز فرمایید
      </v-card-text>
      <v-row align="center" style="margin: 10px">
        <v-col class="d-flex" cols="12" sm="6">
          <b>همراه:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12" lg="4">
          <v-text-field :disabled="ReadOnly" hide-details="auto" v-model="mobile"
            :rules="[rules.required, rules.mobile]" placeholder="09123456789"></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <b></b>
        </v-col>
        <v-col v-if="ReadOnly" class="d-flex" cols="12" sm="12" lg="4">
          <b>شهر</b>
          <v-text-field :disabled="true" ref="cityfromGet" v-model="cityfromGet"></v-text-field>
        </v-col>
        <v-col v-if="!ReadOnly" class="d-flex" cols="12" sm="12" lg="4">
          <b>استان</b>
          <v-select :items="ostans" item-text="text" item-value="value" v-model="ostan"></v-select>
        </v-col>
        <v-col v-if="!ReadOnly" class="d-flex" cols="12" sm="12" lg="4">
          <b>شهرستان</b>
          <v-select :items="cities" item-text="text" item-value="value" v-model="city"></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <b>آدرس:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea :rules="[rules.required]" outlined v-model="address" rows="3" no-resize
            :disabled="ReadOnly"></v-textarea>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <b>کدپستی:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6"><v-text-field :rules="[rules.required, rules.postalCode]"
            :disabled="ReadOnly" ref="postalCode" v-model="postalCode" no-resized></v-text-field>
        </v-col>
        <v-col class="d-flex mt-2" cols="12" sm="6">
          <b>تحویل گیرنده:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12" lg="4">
          <v-text-field :rules="[rules.required]" :disabled="ReadOnly" ref="tahvilGirande" v-model="tahvilGirande"
            no-resized></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-btn v-if="!ReadOnly" color="primary white--text" class="register" rounded @click="onCloseHandler"
          :disabled="apiRunning">
          بستن
        </v-btn>
        <v-btn v-if="!ReadOnly" color="primary white--text" class="register" rounded @click="save()"
          :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ادامه" }}
        </v-btn>
        <v-btn v-if="ReadOnly" color="primary white--text" class="register" rounded @click="edit()"
          :disabled="apiRunning">
          ویرایش
        </v-btn>
        <v-btn v-if="ReadOnly" color="primary white--text" class="register" rounded @click="onPayment()"
          :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "پرداخت" }}
        </v-btn>
      </v-row>
    </v-card></v-form>
</template>

<script>
import { requestMadrak } from "@/api/madrak";
import HistoryButton from "@/components/HistoryButton";
import { getAllOstanCity } from "@/api/location";
import { savePostRequest } from "@/api/post";
import { PostRequestStep_Enum } from "@/utils/constants";
import { startPaymentPostRequest } from "@/api/post";

export default {
  props: ["madrak", "postRequestStep"],
  data() {
    return {
      valid: false,
      rules: {
        required: (value) => !!value || "الزامی",
        postalCode: (value) =>
          String(value)
            .toLowerCase()
            .match(/^[0-9]{10}$/) || "کدپستی اشتباه است",
        mobile: (value) =>
          String(value)
            .toLowerCase()
            .match(/09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}/) ||
          "شماره همراه را درست واردفرمایید",
      },
      //خراسان رضوی
      ostan: "9",
      //مشهد
      city: 2220092,
      address: "",
      mobile: null,
      postalCode: "",
      tahvilGirande: "",
      ostanCities: [],
      paymentUrl: "",
      cityfromGet: "",
      ReadOnly: false,
      EditMode: false,
      ostans: [],
    };
  },
  methods: {
    edit() {
      this.$emit("setStep", PostRequestStep_Enum.EditPostRequest);
    },

    /**
     * check user input
     */
    save() {
      var text = "";
      if (!this.mobile) {
        text = "لطفا شماره همراه را وارد فرمایید.";
      } else if (!this.address) {
        text = "لطفا آدرس را وارد فرمایید.";
      } else if (!this.postalCode) {
        text = "لطفا کدپستی را وارد فرمایید.";
      } else if (!this.tahvilGirande) {
        text = "لطفا نام تحویل گیرنده را وارد فرمایید.";
      } else if (this.city === -1 || this.city === "-1" || !this.city) {
        text = "لطفا استان/شهر را انتخاب فرمایید.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);
        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        savePostRequest({
          srl_madrak: this.madrak.DiplomSerial ?? null,
          srl_city: this.city,
          Address: this.address,
          Mobile: this.mobile,
          PostalCode: this.postalCode,
          TahvilGirandeh: this.tahvilGirande,
        })
          .then((response) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              response?.data?.Message ?? "با موفقیت ذخیره شد"
            );
            this.$emit("setStep", PostRequestStep_Enum.PostPayment);
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          })
          .finally(() => {
            this.$store.commit("SET_API_RUNNING", false);
          });
      }
    },
    onCloseHandler() {
      this.$emit("onClose");
    },
    onPayment() {
      const reqId = this.madrak?.postInfo?.Fserial;
      startPaymentPostRequest(reqId)
        .then((response) => {
          this.paymentUrl = response?.data?.Result;
          if (!!this.paymentUrl) window.location.href = this.paymentUrl;
          else throw response?.data?.Message;
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            error ?? "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

  },
  /**
   * get khorooji meta data
   */
  created() {
    getAllOstanCity()
      .then((response) => {
        this.ostanCities = response.data;
        let ostans = [];
        //همه موارد
        ostans.push({ value: "-1", text: "همه موارد" });
        this.ostanCities.map((item) => {
          if (!ostans.some((el) => el.value === item.srl_Ostan))
            ostans.push({ value: item.srl_Ostan, text: item.name_Ostan });
        });
        this.ostans = ostans;

        this.$store.commit("SET_PROGRESS_SHOW", false);
      })
      .catch((error) => {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
        );
      });
  },
  watch: {
    postRequestStep: {
      immediate: true,
      handler(value) {
        if (value === PostRequestStep_Enum.EditPostRequest) {
          this.ReadOnly = false;
          this.mobile = this.madrak?.postInfo?.Mobile;
          this.address = this.madrak?.postInfo?.Address;
          this.postalCode = this.madrak?.postInfo?.PostalCode;
          this.city = this.madrak?.postInfo?.Srl_city;
          this.ostan = -1;
          this.cityfromGet = this.madrak?.postInfo?.City;
          this.tahvilGirande = this.madrak?.postInfo?.TahvilGirandeh;
        } else if (value === PostRequestStep_Enum.PostPayment) {
          this.ReadOnly = true;
          this.EditMode = false;
          this.mobile = this.madrak?.postInfo?.Mobile;
          this.address = this.madrak?.postInfo?.Address;
          this.postalCode = this.madrak?.postInfo?.PostalCode;
          this.cityfromGet = this.madrak?.postInfo?.City;
          this.tahvilGirande = this.madrak?.postInfo?.TahvilGirandeh;
          /* */
        } else if (value === PostRequestStep_Enum.PostRequest) {
          this.ReadOnly = false;
          this.EditMode = false;
        }
      },
    },

  },
  computed: {
    cities() {
      let cities = [];
      //همه موارد
      cities.push({ value: "-1", text: "همه موارد" });
      this.ostanCities.map((item) => {
        if (item.srl_Ostan === this.ostan)
          cities.push({
            value: item.Fserial,
            text: item.name_City,
          });
      });
      return cities;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    madrakInfo() {
      return this.$store.getters.madrakInfo;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },


};
</script>
<style>
.v-messages__message {
  display: block !important;

  text-align: right;

  font-size: 14px;
  color: red;
  line-height: 1.5 !important;
}
</style>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
